import { fetcher, getHeaders } from './common';


const API_URL = '/api/';

export const setNotification = async (token, data) => {
        const headers = getHeaders(token);
        const url = getUrl();
        const notification = { Token: data.Token };
    
        try {
            fetcher(url, 'POST', headers, notification);
            // console.log(response);
        } catch (error) {
            console.log(error);
            return error;
        }
    };

const getUrl = () => {
	return API_URL + `Notification`;
};